import { createSlice } from '@reduxjs/toolkit';
import {fetchUserTips} from "./thunk";

const TipList = createSlice({
  name: 'TipList',
  initialState: {
    items: [],
    loading: false,
    error: null,
    totalAmount: 0,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserTips.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTips.fulfilled, (state, action) => {
        console.log('f', action);
        state.loading = false;
        state.items = action.payload;
        state.totalAmount = action.payload.reduce(
          (sum, tip) => sum + tip.amount,
          0
        );
      })
      .addCase(fetchUserTips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = TipList.actions;

// Selectors
export const selectAllTips = (state) => state.TipList.items;
export const selectTipsLoading = (state) => state.TipList.loading;
export const selectTipsError = (state) => state.TipList.error;
export const selectTotalTipsAmount = (state) => state.TipList.totalAmount;
export const selectPaidTipsAmount = (state) =>
  state.TipList.items.filter((t) => t.status === 1).reduce((sum, t) => sum + t.amount, 0);
export const selectUnpaidTipsAmount = (state) =>
  state.TipList.items.filter((t) => t.status === 0).reduce((sum, t) => sum + t.amount, 0);

export default TipList.reducer;
